// /**
//  * Lens Pricing Vue Component
//  * ------------------------------------------------------------------------------
//  */


//  import axios from 'axios';
//  import { xhrRequestConfig, getlensPricingUrl } from '../utils/api.js';
  
//  const LENS_PRICING_URL = getlensPricingUrl();
  
//  export default function lensPricing() {
//      return {
//          data: {
//              cleanedCartLineItems: null,
//              updatedCartLineItems: null,
//              lensPricingCartItems: null
//          },
  
//           methods: {
//               // Set up the configuration of the data
//               lensPricingEntry() {
  
//                   //////////////////////////////////////////
//                   // Get all the cart items and reset all of the edited/discounted values to get a clean cart state
//                   //////////////////////////////////////////
//                   this.cleanedCartLineItems = this.cart.items.map( cartItem => {
//                       // rebuild properties into an object for easy reference later
//                       cartItem.properties = Array.isArray(cartItem.properties) ? Object.fromEntries(cartItem.properties) : cartItem.properties;
  
//                       // Reset all the discount and pricing values, and flag the product as requiring a change
//                       if (!!cartItem.properties['_discountMessage']) delete cartItem.properties['_discountMessage'];
//                       if (!!cartItem.properties['_isDiscounted']) delete cartItem.properties['_isDiscounted'];
//                       if (!!cartItem.properties['_totalSavings']) delete cartItem.properties['_totalSavings'];
//                       if (!!cartItem.properties['_shownPrice']) delete cartItem.properties['_shownPrice'];
//                       if (!!cartItem.properties['_totalPrice']) delete cartItem.properties['_totalPrice'];
 
//                        // option product
//                       if (!!cartItem.properties['_optionProduct']) {
//                          cartItem.properties['_totalPrice'] = cartItem.properties['_basePrice'] * cartItem.quantity;
//                       } 
//                       // base Product
//                       else { 
//                          let origPrice = (cartItem.properties['_basePrice'] + cartItem.properties['_totalOptions']) * cartItem.quantity;
//                          cartItem.properties['_totalPrice'] = origPrice;
//                          cartItem.properties['_shownPrice'] = origPrice;
//                       }

//                         let getBasePrice = !!cartItem.properties['_baseCompareAtPrice'] ? cartItem.properties['_baseCompareAtPrice'] : cartItem.properties['_basePrice'];
                            
//                       cartItem.properties['_totalSavings'] = (getBasePrice - cartItem.properties['_basePrice']);

//                       return cartItem;
//                   });
  
//                   // then sort out the base products and their options, but get the cleaned product first
//                   this.lensPricingCartItems = this.cartProducts.baseProducts.map( baseProductOriginal => {
//                       // cleaned up reference product
//                       let baseProduct = this.cart.items.find( cartItem => cartItem.key === baseProductOriginal.key );
 
//                       let lensPriceRequestData = {};
                      
//                           // rebuild properties into an object for easy reference later
//                           baseProduct.properties = Array.isArray(baseProduct.properties) ? Object.fromEntries(baseProduct.properties) : baseProduct.properties;
  
//                       // set up all the values for the request to check the lens price discounts
//                       lensPriceRequestData = {
//                           "variant_id": baseProduct.id,
//                           "total_price": (baseProduct.properties['_basePrice'] + baseProduct.properties['_totalOptions']),
//                           "vendor": baseProduct.vendor,
//                           "base_price": baseProduct.properties['_basePrice'],
//                           "key": baseProduct.key,
//                           "quantity": baseProduct.quantity,
//                           "options_price": baseProduct.properties['_totalOptions']
//                       };
  
//                       if (!!baseProduct.properties['_prescriptionOptionGroup']) {
//                           let optionGroupKey = baseProduct.properties['_prescriptionOptionGroup'],
//                               productOptions = 
                              
//                                   this.cartProducts.optionProducts.map( optionProduct => {
//                                       // convert option product props to object for easier time later
//                                       optionProduct.properties = Array.isArray(optionProduct.properties) ? Object.fromEntries(optionProduct.properties) : optionProduct.properties;
  
//                                       // make sure it has the props we want, and that they match the current option group key
//                                       let hasPrescriptionOptionGroup = !!optionProduct.properties['_prescriptionOptionGroup'],
//                                           optionGroupMatches = !!hasPrescriptionOptionGroup ? (optionProduct.properties['_prescriptionOptionGroup'] === optionGroupKey) : false,
//                                           output = false;
  
//                                       if (!!optionGroupMatches) {
//                                           output = {
//                                               "key" : optionProduct.key,
//                                               "variant_id": optionProduct.id,
//                                               "price" : optionProduct.properties['_basePrice']
//                                           }
//                                       }
//                                       return output;
//                                   })
//                                   // then cut out the empty responses
//                                   .filter( product => !!product);
  
//                           lensPriceRequestData['option_products'] = productOptions;
//                       };
  
//                       return {
//                           ...baseProduct,
//                           lensPriceRequestData: lensPriceRequestData
//                       };
//                   });
  
//                   if (!!this.lensPricingCartItems.length) {
//                       this._lensPricingController();
//                   } else {
//                       this.isCartLoading = false;
//                   }
//               },
  
//               async _lensPricingController() {
//                   // build the request object from the cart items
//                   let data = {
//                       'products': this.lensPricingCartItems.reduce( (acc, item) => {
                            
//                          // Duplicate each line item if they have multiple quantity. 
//                          // This makes life easier for the middleware. We could have a single line item, with qty of 2 or more, 
//                          // be both the trigger and target of a discount. If SPLIT comes back TRUE, then we can apply the
//                          // discount to ONE of the Line Item quantities, and separate it into its own product later on
                          
//                           let output = [];
  
//                           for (let i = 0; i < item.quantity; i++) {
//                               output.push(item.lensPriceRequestData);
//                           };
  
//                           return [
//                               ...acc,
//                               ...output
//                           ];
  
//                       }, [])
//                   };
  
//                   // if there is any products to check..
//                   if (!!data.products.length) {

//                       // ...get the lens pricing data
//                      let lensData = await this._getLensPriceRules(data);

//                     // we need to check over and update the product data even if there is no lens discounts,
//                     // because we  need to cater for other discounts (eg. shopify discounts)
//                     this._handleDiscounts(lensData);
//                     await this._updateCartWithLensData();
//                     this.getCart();

//                     //   if (!!lensData && !!lensData.length) {

//                           // and update the products, then update the cart

//                     //   } 
//                     //   // if there is no discounts, we need to run the same thing but without any property updates
//                     //   else {

//                     //     this.updatedCartLineItems = this.cleanedCartLineItems;
//                     //     await this._updateCartWithLensData();
//                     //     this.getCart();
//                     //     //   this.isCartLoading = false;
                        
//                     //   }
//                   }
//               }, 
  
//               _getLensPriceRules(data) {
//                   return axios.post(LENS_PRICING_URL, data, xhrRequestConfig)
//                       .then( response => response.data)
//                       .then( data => {
//                           // flatten the base data
//                           let output = Object.values(data.rules[0]).flat();

//                           // then map over the items and promote the option products
//                           output = output.map( e => {
//                             if (!!e.option_products) {
//                                 return [
//                                     e,
//                                     ...e.option_products
//                                 ]
//                             } else {
//                                 return e;
//                             }
//                         });

//                         // then flatten again
//                         output = output.flat();   

//                         return output;
//                       })
//                       .catch((error) => {
//                           console.log(error.response);
//                       });
//               },
  
//               _handleDiscounts(rules) {
//                   // - apply rules / lens discounts
//                   // - apply any other discounting applied by Shopify

//                 //   if (!!rules.length) {
//                     //   We go over all of the items and update the line item props with any discount rules returned
//                     let output = this.cleanedCartLineItems.reduce( (acc, baseProduct) => {
                              
//                         let ruleOutput = [],
//                             updatedBaseProduct = baseProduct,
//                             optionsDiscounts = 0,
//                             otherDiscounts = 0

//                         // find the product that matches the rule, if applicable
//                         // we can iterate over the lensPricingCartItems because those were baseProducts to start with
//                         let rule = rules.find( rule => rule.key === baseProduct.key );

//                         // if a rule exists then update the props
//                         if (!!rule) {

//                             updatedBaseProduct = this._updateLineItemWithRules(rule, updatedBaseProduct);
                        
//                             // if there is option products, take the discount values and 
//                             // add them against the displayed data for the base/parent product

//                             if (!!rule.option_products) {
//                                 // if the option products are discounted we need to pass the discount amount back up to the parent, so the users see the correct values
//                                 optionsDiscounts = rule.option_products.reduce( (acc, product) => acc + product.discount_amount, 0);
//                             };
//                         }
                        
                        
//                         // we also need to check if it has any other discounts and include those, too
//                         if (!!baseProduct.discount_allocation.length) {
//                             // go over all the discounts, but ignore _cartPriceUpdate
//                             otherDiscounts = updatedBaseProduct.discount_allocation.reduce( (acc, discount) => {
//                                 if ( discount.title.toLowerCase() !== '_cartpriceupdate' ) {
//                                     return acc += parseInt(discount.amount);
//                                 } else {
//                                     return acc;
//                                 }
//                             }, 0);
//                         }


//                         console.log("!!", otherDiscounts);
                        
//                         // need to include the base product in the output, if it has:
//                         // - any changes made from lens rules or cart discounts

//                         if (!!rule || !!baseProduct.discount_allocation.length) {

//                             // Update some of the props with all the final data

//                             // update the totalPrice to reflect any discount_allocations that are applied to THIS base product only
//                             updatedBaseProduct.properties._totalPrice = updatedBaseProduct.properties._totalPrice - otherDiscounts;

//                             // add together all the various discounts with the other savings values, for reference latertrigger_product_change
//                             updatedBaseProduct.properties._totalSavings = updatedBaseProduct.properties._totalSavings + optionsDiscounts + otherDiscounts;

//                             console.log("??", otherDiscounts);

//                             // add the lens discounts on any option products
//                             if (!!optionsDiscounts) {
//                                 updatedBaseProduct.properties._lensDiscountSavings = optionsDiscounts;
//                             }

//                             // update the shown price so it includes the Base product, option products, and all discounts
//                             let getBasePrice = !!updatedBaseProduct.properties['_baseCompareAtPrice'] ? updatedBaseProduct.properties['_baseCompareAtPrice'] : updatedBaseProduct.properties['_basePrice'];

//                             // if totalOptions is 0, then we can use the compareAtPrice as the total, otherwise, we need to use the basePrice 
//                             // otherwise the displayed price gets weird, even though the calculations and totals are correct
//                             // let getBasePrice = !!updatedBaseProduct.properties['_totalOptions'] ? updatedBaseProduct.properties['_basePrice'] :
//                             // (!!updatedBaseProduct.properties['_baseCompareAtPrice'] ? updatedBaseProduct.properties['_baseCompareAtPrice'] : updatedBaseProduct.properties['_basePrice']);
                            
//                             let fullPrice = (getBasePrice + updatedBaseProduct.properties['_totalOptions']) * updatedBaseProduct.quantity;

//                             updatedBaseProduct.properties._shownPrice = fullPrice - updatedBaseProduct.properties._totalSavings;

//                             ruleOutput = [
//                                 ...ruleOutput,
//                                 updatedBaseProduct
//                             ];
//                         };
                        
//                         return [
//                             ...acc,
//                             ...ruleOutput
//                         ]
//                     }, []);
  
//                     this.updatedCartLineItems = output;
//                 // };
                  
//             },
  
//               _updateLineItemWithRules(rule, product) {
//                   let output = product;

//                   let baseSaving = (!!product.properties._baseCompareAtPrice ? product.properties._baseCompareAtPrice : product.properties._basePrice) - product.properties._basePrice;
 
//                   // apply the discounts and add new properties
//                   output.properties['_totalSavings'] = baseSaving + rule.discount_amount;
//                   output.properties['_lensDiscountSavings'] = rule.discount_amount;
//                   output.properties['_totalPrice'] = rule.discounted_price;
  
//                   if (!!rule.message) output.properties['_discountMessage'] = `${rule.message}`;
//                   if (!!rule.discount_amount) output.properties['_isDiscounted'] = true;
  
//                   return output
//               },
  
//               async _resetCart() {
//                 return axios.post('/cart/clear.js');
//               },

//               async _updateCartWithLensData() {

//                   await this._resetCart();
  
//                   let cartRebuildData = {
//                       "items": this.updatedCartLineItems.map( lineItem => {
//                           return {
//                             "quantity": lineItem.quantity,
//                             "id": lineItem.id,
//                             "properties": lineItem.properties
//                           }
//                       })
//                   };
  
//                   // Multiple requests used because change.js only takes 1 item at a time.
//                   // Can't use Promise.all to make these at the same time either because
//                   // they seem to conflict and produces unexpected results.
//                   return axios.post('/cart/add.js', cartRebuildData).then( response => {
//                       return true;
//                   }).catch((error) => {
//                       console.log(`${lineItem.key} change request failed`, error);
//                   });
//               }
  
//           }
//       }
//  };

/**
 * Lens Pricing Vue Component
 * ------------------------------------------------------------------------------
 */


 import axios from 'axios';
 import { xhrRequestConfig, getlensPricingUrl } from '../utils/api.js';
  
 const LENS_PRICING_URL = getlensPricingUrl();
  
 export default function lensPricing() {
     return {
         data: {
             cleanedCartLineItems: null,
             updatedCartLineItems: null,
             lensPricingCartItems: null
         },
  
          methods: {
              // Set up the configuration of the data
              lensPricingEntry() {
  
                  //////////////////////////////////////////
                  // Get all the cart items and reset all of the edited/discounted values to get a clean cart state
                  //////////////////////////////////////////
                  this.cleanedCartLineItems = this.cart.items.map( cartItem => {
                      // rebuild properties into an object for easy reference later
                      cartItem.properties = Array.isArray(cartItem.properties) ? Object.fromEntries(cartItem.properties) : cartItem.properties;
  
                      // Reset all the discount and pricing values, and flag the product as requiring a change
                      if (!!cartItem.properties['_discountMessage']) delete cartItem.properties['_discountMessage'];
                      if (!!cartItem.properties['_isDiscounted']) delete cartItem.properties['_isDiscounted'];
                      if (!!cartItem.properties['_totalSavings']) delete cartItem.properties['_totalSavings'];
                      if (!!cartItem.properties['_shownPrice']) delete cartItem.properties['_shownPrice'];
                      if (!!cartItem.properties['_totalPrice']) delete cartItem.properties['_totalPrice'];
 
                       // option product
                      if (!!cartItem.properties['_optionProduct']) {
                         cartItem.properties['_totalPrice'] = cartItem.properties['_basePrice'] * cartItem.quantity;
                      } 
                      // base Product
                      else { 
                         let origPrice = (cartItem.properties['_basePrice'] + cartItem.properties['_totalOptions']) * cartItem.quantity;
                         cartItem.properties['_totalPrice'] = origPrice;
                         cartItem.properties['_shownPrice'] = origPrice;
                      }

                        let getBasePrice = !!cartItem.properties['_baseCompareAtPrice'] ? cartItem.properties['_baseCompareAtPrice'] : cartItem.properties['_basePrice'];
                            
                      cartItem.properties['_totalSavings'] = (getBasePrice - cartItem.properties['_basePrice']);

                      return cartItem;
                  });
  
                  // then sort out the base products and their options, but get the cleaned product first
                  this.lensPricingCartItems = this.cartProducts.baseProducts.map( baseProductOriginal => {
                      // cleaned up reference product
                      let baseProduct = this.cart.items.find( cartItem => cartItem.key === baseProductOriginal.key );
 
                      let lensPriceRequestData = {};
                      
                          // rebuild properties into an object for easy reference later
                          baseProduct.properties = Array.isArray(baseProduct.properties) ? Object.fromEntries(baseProduct.properties) : baseProduct.properties;
  
                      // set up all the values for the request to check the lens price discounts
                      lensPriceRequestData = {
                          "variant_id": baseProduct.id,
                          "total_price": (baseProduct.properties['_basePrice'] + baseProduct.properties['_totalOptions']),
                          "vendor": baseProduct.vendor,
                          "base_price": baseProduct.properties['_basePrice'],
                          "key": baseProduct.key,
                          "quantity": baseProduct.quantity,
                          "options_price": baseProduct.properties['_totalOptions']
                      };
  
                      if (!!baseProduct.properties['_prescriptionOptionGroup']) {
                          let optionGroupKey = baseProduct.properties['_prescriptionOptionGroup'],
                              productOptions = 
                              
                                  this.cartProducts.optionProducts.map( optionProduct => {
                                      // convert option product props to object for easier time later
                                      optionProduct.properties = Array.isArray(optionProduct.properties) ? Object.fromEntries(optionProduct.properties) : optionProduct.properties;
  
                                      // make sure it has the props we want, and that they match the current option group key
                                      let hasPrescriptionOptionGroup = !!optionProduct.properties['_prescriptionOptionGroup'],
                                          optionGroupMatches = !!hasPrescriptionOptionGroup ? (optionProduct.properties['_prescriptionOptionGroup'] === optionGroupKey) : false,
                                          output = false;
  
                                      if (!!optionGroupMatches) {
                                          output = {
                                              "key" : optionProduct.key,
                                              "variant_id": optionProduct.id,
                                              "price" : optionProduct.properties['_basePrice']
                                          }
                                      }
                                      return output;
                                  })
                                  // then cut out the empty responses
                                  .filter( product => !!product);
  
                          lensPriceRequestData['option_products'] = productOptions;
                      };
  
                      return {
                          ...baseProduct,
                          lensPriceRequestData: lensPriceRequestData
                      };
                  });
  
                  if (!!this.lensPricingCartItems.length) {
                      this._lensPricingController();
                  } else {
                      this.isCartLoading = false;
                  }
              },
  
              async _lensPricingController() {
                  // build the request object from the cart items
                  let data = {
                      'products': this.lensPricingCartItems.reduce( (acc, item) => {
                            
                         // Duplicate each line item if they have multiple quantity. 
                         // This makes life easier for the MW. We could have a single line item, with qty of 2 or more, 
                         // be both the trigger and target of a discount. If SPLIT comes back TRUE, then we can apply the
                         // discount to ONE of the Line Item quantities, and separate it into its own product later on
                          
                          let output = [];
  
                          for (let i = 0; i < item.quantity; i++) {
                              output.push(item.lensPriceRequestData);
                          };
  
                          return [
                              ...acc,
                              ...output
                          ];
  
                      }, [])
                  };
  
                  // if there is any products to check..
                  if (!!data.products.length) {

                      // ...get the lens pricing data
                     let lensData = await this._getLensPriceRules(data);

                      // if there is no data then its probably returned an error so we can just skip it
                      if (!!lensData && !!lensData.length) {

                          // and update the products, then update the cart
                          this._handleDiscounts(lensData);
                          await this._updateCartWithLensData();
                          this.getCart();

                      } 
                      // if there is no discounts, we need to run the same thing but without any property updates
                      else {

                        this.updatedCartLineItems = this.cleanedCartLineItems;
                        await this._updateCartWithLensData();
                        this.getCart();
                        //   this.isCartLoading = false;
                        
                      }
                  }
              }, 
  
              _getLensPriceRules(data) {
                  return axios.post(LENS_PRICING_URL, data, xhrRequestConfig)
                      .then( response => response.data)
                      .then( data => {
                          // flatten the base data
                          let output = Object.values(data.rules[0]).flat();

                          // then map over the items and promote the option products
                          output = output.map( e => {
                            if (!!e.option_products) {
                                return [
                                    e,
                                    ...e.option_products
                                ]
                            } else {
                                return e;
                            }
                        });

                        // then flatten again
                        output = output.flat();   

                        return output;
                      })
                      .catch((error) => {
                          console.log(error.response);
                      });
              },
  
              _handleDiscounts(rules) {
                  // - apply rules / lens discounts
                  // - apply any other discounting applied by Shopify

                  if (!!rules.length) {
                    //   We go over all of the items and update the line item props with any discount rules returned
                    let output = this.cleanedCartLineItems.reduce( (acc, baseProduct) => {
                              
                        let ruleOutput = [],
                            updatedBaseProduct = baseProduct,
                            optionsDiscounts = 0,
                            otherDiscounts = 0

                        // find the product that matches the rule, if applicable
                        // we can iterate over the lensPricingCartItems because those were baseProducts to start with
                        let rule = rules.find( rule => rule.key === baseProduct.key );

                        // if a rule exists then update the props
                        if (!!rule) {

                            updatedBaseProduct = this._updateLineItemWithRules(rule, updatedBaseProduct);
                        
                            // if there is option products, take the discount values and 
                            // add them against the displayed data for the base/parent product

                            if (!!rule.option_products) {
                                // if the option products are discounted we need to pass the discount amount back up to the parent, so the users see the correct values
                                optionsDiscounts = rule.option_products.reduce( (acc, product) => acc + product.discount_amount, 0);
                            };
                        }
                        
                        
                        // we also need to check if it has any other discounts and include those, too
                        if (!!baseProduct.discount_allocation) {
                            // go over all the discounts, but ignore _cartPriceUpdate
                            otherDiscounts = updatedBaseProduct.discount_allocation.reduce( (acc, discount) => {
                                if ( discount.title.toLowerCase() !== '_cartpriceupdate' ) {
                                    return acc += parseInt(discount.amount);
                                } else {
                                    return acc;
                                }
                            }, 0);
            
                            // updatedBaseProduct.trigger_product_change = true;
                        }

                        
                        // need to include the base product in the output, if it has:
                        // - any changes made from rules or discounts
                        // - has trigger_product_change = true 

                        // if (!!baseProduct.trigger_product_change || !!rule || !!baseProduct.discount_allocation) {
                        if (!!rule || !!baseProduct.discount_allocation) {

                            // Update some of the props with all the final data

                            // update the totalPrice to reflect any discount_allocations that are applied to THIS base product only
                            updatedBaseProduct.properties._totalPrice = updatedBaseProduct.properties._totalPrice - otherDiscounts;

                            // add together all the various discounts with the other savings values, for reference later
                            updatedBaseProduct.properties._totalSavings = updatedBaseProduct.properties._totalSavings + optionsDiscounts + otherDiscounts;

                            // add the lens discounts on any option products
                            if (!!optionsDiscounts) {
                                updatedBaseProduct.properties._lensDiscountSavings = optionsDiscounts;
                            }

                            // update the shown price so it includes the Base product, option products, and all discounts
                            let getBasePrice = !!updatedBaseProduct.properties['_baseCompareAtPrice'] ? updatedBaseProduct.properties['_baseCompareAtPrice'] : updatedBaseProduct.properties['_basePrice'];

                            // if totalOptions is 0, then we can use the compareAtPrice as the total, otherwise, we need to use the basePrice 
                            // otherwise the displayed price gets weird, even though the calculations and totals are correct
                            // let getBasePrice = !!updatedBaseProduct.properties['_totalOptions'] ? updatedBaseProduct.properties['_basePrice'] :
                            // (!!updatedBaseProduct.properties['_baseCompareAtPrice'] ? updatedBaseProduct.properties['_baseCompareAtPrice'] : updatedBaseProduct.properties['_basePrice']);
                            
                            let fullPrice = (getBasePrice + updatedBaseProduct.properties['_totalOptions']) * updatedBaseProduct.quantity;

                            updatedBaseProduct.properties._shownPrice = fullPrice - updatedBaseProduct.properties._totalSavings;

                            ruleOutput = [
                                ...ruleOutput,
                                updatedBaseProduct
                            ];
                        };
                        
                        return [
                            ...acc,
                            ...ruleOutput
                        ]
                    }, []);
                    //   cut out any null/false values or products that don't need to change
                    // .filter( product => !!product && !!product.trigger_product_change );
  
                    this.updatedCartLineItems = output;
                };
                  
            },
  
              _updateLineItemWithRules(rule, product) {
                  let output = product;

                  let baseSaving = (!!product.properties._baseCompareAtPrice ? product.properties._baseCompareAtPrice : product.properties._basePrice) - product.properties._basePrice;
 
                  // apply the discounts and add new properties
                  // output.trigger_product_change = true;
                  output.properties['_totalSavings'] = baseSaving + rule.discount_amount;
                  output.properties['_lensDiscountSavings'] = rule.discount_amount;
                  output.properties['_totalPrice'] = rule.discounted_price;
  
                  if (!!rule.message) output.properties['_discountMessage'] = `${rule.message}`;
                  if (!!rule.discount_amount) output.properties['_isDiscounted'] = true;
  
                  return output
              },
  
              async _resetCart() {
                return axios.post('/cart/clear.js');
              },

              async _updateCartWithLensData() {

                  await this._resetCart();
  
                  let cartRebuildData = {
                      "items": this.updatedCartLineItems.map( lineItem => {
                          return {
                            "quantity": lineItem.quantity,
                            "id": lineItem.id,
                            "properties": lineItem.properties
                          }
                      })
                  };
  
                  // Multiple requests used because change.js only takes 1 item at a time.
                  // Can't use Promise.all to make these at the same time either because
                  // they seem to conflict and produces unexpected results.
                  return axios.post('/cart/add.js', cartRebuildData).then( response => {
                      return true;
                  }).catch((error) => {
                      console.log(`${lineItem.key} change request failed`, error);
                  });
              }
  
          }
      }
 };